import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const WorkWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default WorkWrapper